import PaymentDistributionKirovograd from "@/plugins/api/factories/PaymentDistributionKirovograd";

export const state = {
  distributionDebt: 0,
  distributionData: {
    ls: null,
    amount: null,
    card_token: null,
    name_app_id: "",
    save_card: false,
  },
  paymentUrl: null,
  paymentResponse: null,
  processing3DS: false,
  error: null, // Состояние для хранения ошибки
  invalidAccount: false, // Флаг для отслеживания невалидного аккаунта
};

export const actions = {
  async createDistributionOrderKirovograd({ commit, state }, params) {
    console.log(
      "CHLENIX createDistributionOrderKirovograd REQUEST: " +
        JSON.stringify(params)
    );
    return await PaymentDistributionKirovograd.createDistributionOrderKirovograd(
      { ...state.distributionData, ...params },
      async (response) => {
        console.log(
          "CHLENIX createDistributionOrderKirovograd response: " +
            JSON.stringify(response)
        );
        // Обработка ответа с 3D Secure
        if (response.status === "Need3Ds") {
          commit("SET_PROCESSING_3DS", true);
          const redirectUrl =
            response.action || response.alternativeRedirectUrl;
          console.log("3D Secure redirect URL:", redirectUrl);
          commit("SET_PAYMENT_URL", redirectUrl);
          commit("SET_PAYMENT_RESPONSE", response);
        } else if (response.status === "success" && response.url) {
          commit("SET_PAYMENT_URL", response.url);
          commit("SET_PAYMENT_RESPONSE", response);
        } else if (response.status === "success" || response.mode === 1) {
          // Для успешных платежей без URL (прямой платеж)
          commit("SET_PAYMENT_RESPONSE", response);
        }
        return response;
      }
    );
  },

  async createDistributionToOrderKirovograd({ commit, state }, params) {
    return await PaymentDistributionKirovograd.createDistributionToOrderKirovograd(
      { ...state.distributionData, ...params },
      async (response) => {
        // Обработка ответа с 3D Secure
        if (response.status === "Need3Ds") {
          commit("SET_PROCESSING_3DS", true);
          commit(
            "SET_PAYMENT_URL",
            response.alternativeRedirectUrl || response.action
          );
          commit("SET_PAYMENT_RESPONSE", response);
        } else if (response.status === "success" && response.url) {
          commit("SET_PAYMENT_URL", response.url);
          commit("SET_PAYMENT_RESPONSE", response);
        } else if (response.status === "success" || response.mode === 1) {
          // Для успешных платежей без URL (прямой платеж)
          commit("SET_PAYMENT_RESPONSE", response);
        }
        return response;
      }
    );
  },

  async getKirovogradAccountDistributionDebt({ commit }, params) {
    try {
      const response =
        await PaymentDistributionKirovograd.getKirovogradAccountDistributionDebt(
          params,
          async (response) => {
            console.log(`getKirovogradAccountDistributionDebt`, response);
            // Сбрасываем предыдущую ошибку
            commit("SET_ERROR", null);
            commit("SET_INVALID_ACCOUNT", false);

            if (response.status === "success" && response.accountInfo) {
              // Преобразуем строковое значение Борг в число
              const debt = parseFloat(response.accountInfo.Борг) || 0;
              console.log("Преобразованное значение долга:", debt);
              commit("SET_DISTRIBUTION_DEBT", debt);
            } else if (response.status === "error") {
              // Если получена ошибка, сохраняем её и устанавливаем флаг невалидного аккаунта
              console.error("Ошибка получения долга:", response);
              commit("SET_ERROR", response);
              commit("SET_INVALID_ACCOUNT", true);
            }
            return response;
          }
        );
      return response;
    } catch (error) {
      console.error("Ошибка при запросе долга распределения:", error);
      commit("SET_ERROR", {
        status: "error",
        message:
          "Загальна помилка при отриманні інформації про заборгованість.",
        error_details:
          error.message || "Failed to get valid response from EasyPay API",
      });
      commit("SET_INVALID_ACCOUNT", true);
      return { status: "error" };
    }
  },
};

export const mutations = {
  SET_DISTRIBUTION_DEBT(state, debt) {
    state.distributionDebt = debt;
  },
  SET_PAYMENT_URL(state, url) {
    state.paymentUrl = url;
    console.log("Установлен URL платежа в PaymentDistributionKirovograd:", url);
  },
  SET_PAYMENT_RESPONSE(state, response) {
    state.paymentResponse = response;
  },
  SET_PROCESSING_3DS(state, processing) {
    state.processing3DS = processing;
  },
  RESET_PAYMENT_STATE(state) {
    state.paymentUrl = null;
    state.paymentResponse = null;
    state.processing3DS = false;
    state.error = null;
    // Сбрасываем значение долга, чтобы не показывать чужой долг
    state.distributionDebt = 0;
    // При смене аккаунта сбрасываем флаг invalidAccount
    state.invalidAccount = false;
    // Сбрасываем данные распределения
    state.distributionData = {
      ls: null,
      amount: null,
      card_token: null,
      name_app_id: "",
      save_card: false,
    };
    console.log("Полный сброс состояния модуля PaymentDistributionKirovograd");
  },
  SET_DISTRIBUTION_DATA(state, data) {
    state.distributionData = {
      ...state.distributionData,
      ...data,
    };
  },

  // Полный сброс данных распределения
  RESET_DISTRIBUTION_DATA(state) {
    state.distributionData = {
      ls: null,
      amount: null,
      card_token: null,
      name_app_id: this.$store.state.Auth.nativeData.id,
      save_card: false,
    };
    console.log("Данные распределения полностью сброшены");
  },
  // Мутация для установки ошибки
  SET_ERROR(state, error) {
    state.error = error;
  },
  // Мутация для установки флага невалидного аккаунта
  SET_INVALID_ACCOUNT(state, value) {
    state.invalidAccount = value;
  },
  // Мутация для установки токена карты
  SET_CARD_TOKEN(state, token) {
    state.distributionData.card_token = token;
    console.log(
      "Токен карты установлен в PaymentDistributionKirovograd:",
      token
    );
  },
};
